import { FormattedMessage, useIntl } from "react-intl";
import React, { useState } from "react";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "../../../../components";

export function CheckoutFormWrapper({ children, title, style }) {
  return (
    <div className={"checkout-form-wrapper"} style={style}>
      <div className="checkout-left-ui">
        <h4 className="heading-ui">{title}</h4>
        <div className="checkout-content-wrap white-wrap">{children}</div>
      </div>
    </div>
  );
}
export function Field({
  label,
  placeholder,
  value,
  onChange,
  required,
  isEmailField = false,
}) {
  const [tooltipToggle, setTooltipToggle] = useState(false);
  const intl = useIntl();

  const inputVerification = (e) => {
    if (!isEmailField && e.target.value.length >= 30) {
      setTooltipToggle(true);
    } else {
      setTooltipToggle(false);
    }
    onChange(e);
  };
  return (
    <div className="form-group ">
      <label>
        {label} {required ? <span>*</span> : ""}{" "}
      </label>
      <input
        type="text"
        placeholder={placeholder}
        onChange={inputVerification}
        value={value}
        required={required}
        maxLength={!isEmailField && "30"}
      />
      {tooltipToggle && (
        <OverlayTrigger
          placement="bottom"
          show={true}
          overlay={(props) =>
            Tooltip({
              ...props,
              data: intl.formatMessage({
                id: "billing.thisInputCanNotContainMoreThen30Chars",
              }),
            })
          }
        >
          <div />
        </OverlayTrigger>
      )}
    </div>
  );
}
